import { useAuth } from "../contexts/AuthContext";
import { permissionsFactory } from "../utils/utils";
import VCenteredContainer from '../components/containers/VCenteredContainer';
import Dashboard from '../components/dashboard/Dashboard';

const Home = () => {  
  const { user } = useAuth();
  const { permissions } = useAuth();
  const grantedPermissions = permissionsFactory(permissions);

  if (grantedPermissions.canViewReport) {
    return (
      <div className="h-full w-full">
        <Dashboard/>
      </div>
    );
  }

  return (    
    <VCenteredContainer>
      <div className={'titleContainer'}>
        <h1 className='text-5xl font-bold'>Olá {user?.first_name ? user.first_name : ''}! </h1>
      </div>
    </VCenteredContainer>
  )
}

export default Home